"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const OverclaimStatusIndicator_1 = __importDefault(require("@Components/StatusPills/OverclaimStatusIndicator"));
const overclaim_filter_status_helper_1 = require("@App/helpers/work-entities/utils/overclaim_filter_status_helper");
const StatusSection = (props) => {
    const { statusCounts } = props;
    return (react_1.default.createElement("div", { className: 'overclaim-status-section' }, Object.keys(overclaim_filter_status_helper_1.OVERCLAIM_FILTER_STATUS).map((overclaimKey, index) => {
        var _a;
        return (react_1.default.createElement(OverclaimStatusIndicator_1.default, { key: index, overclaimStatus: overclaimKey, count: (_a = statusCounts[overclaimKey]) !== null && _a !== void 0 ? _a : 0, withCount: true }));
    })));
};
exports.default = StatusSection;
